export enum FilestoreTypeEnum {
    Unknown = 0,
    //        UserProfilePictures = 1,
    Attachments = 2,
    Images = 3,
    //        Thumbnails = 4,
    GisData = 5,
    //    Exports = 6,
    //    Reports = 7,
    //    QuickTrends = 8,
    GisPrjData = 9,
    HmiImages = 10,
    //    ReportTemplates = 11,
    //    QuickTrendsJSON = 12,
    //    DynacardQuickTrends = 13,
    //    DynacardQuickTrendsJSON = 14,
    //    EmailAttachments = 15,
    //    DataFileImport = 16,
    //    DataFileImportLog = 17,
    //    ObjectAdmin = 18,
    //    ObjectAdminLog = 19,
    //    ReportingJSON = 20,
    //    TrendingJSON = 21
    GisKmzData = 23,
    HmiThumbnails = 24,
    HmiSharedImages = 25,
    HmiSharedThumbnails = 26
}
